import {createEvent} from "effector";

export const toggleDarkThemeEv = createEvent()

export const changeUserDataEv = createEvent()

export const sendRegistrationDataEv = createEvent()

export const setNextStepEv = createEvent()

export const formIsValidEv = createEvent()

export const setFormClickedButtonEv = createEvent()
